




































































































































































import queryString from "query-string";
import Vue from "vue";
import Logo from "./Logo.vue";
import ErrorMessages from "./ErrorMessages.vue";
import axios from "axios";
import VueCookies from "vue-cookies";

Vue.use(VueCookies);

interface LanguageItem {
  text: string;
  value: string;
  flag: string;
}

interface ThemeItem {
  text: string;
  value: string;
}

export default Vue.extend({
  name: "LoginForm",

  components: {
    Logo,
    ErrorMessages,
  },

  data: () => ({
    themes: [] as { text: string; value: string }[],
    selectedTheme: "",
    themeEnabled: true,
    clients: [] as string[],
    languages: [] as { text: string; value: string; flag: string }[],
    releases: [] as string[],
    selectedRelease: null as string | null,
    showReleases: false,
    application: "",
    releaseEnabled: true,
    language: "",
    theme: "",
    clientEnabled: false,
    isDisabled: true,
  }),
  methods: {
    changeTheme(theme: string): void {
      const isDark: boolean = theme === "dark";
      this.$vuetify.theme.dark = isDark;
    },
    changeLocale(lang: string): void {
      this.$vuetify.lang.current = lang;
    },
    submitForm(): void {
      const loginForm = document.getElementById("loginForm") as HTMLFormElement;
      if (loginForm) {
        loginForm.submit();
      }
    },
    getBrowserLang(): string {
      return window.navigator.language;
    },
    defaultLanguage(lang: string): string {
      const defaultLanguage: string = this.language;
      const query = queryString.parse(window.location.search);
      const cookievalue: string | undefined = Vue.$cookies.get("CS_LANGUAGE");
      let language: string =
        lang != null && lang != ""
          ? lang
          : cookievalue
          ? cookievalue
          : this.getBrowserLang();
      language = language.substr(0, 2).toLowerCase();
      language = query.countries
        ? (query.countries as string)
        : query.lang
        ? (query.lang as string)
        : language;

      switch (language) {
        case "en":
        case "de":
        case "it":
        case "ru":
        case "fr":
        case "es":
          break;
        default:
          language = defaultLanguage;
      }
      return language;
    },
    checkUserMandant(): void {
      if (this.$data.clientEnabled) {
        if (
          this.query &&
          this.query.username &&
          this.query.username.trim() !== ""
        ) {
          const url: string =
            "../REST/adminmandator/list/user/" +
            encodeURIComponent(this.query.username) +
            "?time=" +
            Date.now();
          axios
            .get(url)
            .then((response) => {
              this.clients = response.data as string[];
              this.isDisabled = false;
            })
            .catch((error) => {
              if (error.response && error.response.status === 404) {
                this.clients = [];
                this.isDisabled = false;
              } else {
                this.isDisabled = true;
                console.error(error);
              }
            });
        } else {
          this.isDisabled = true;
        }
      } else {
        this.clients = [];
        this.isDisabled = false;
      }
    },
    fetchLanguages(): void {
      axios
        .get<string[]>("../REST/loginconfig/languages")
        .then((response) => {
          const serverLanguages: string[] = response.data;
          this.languages = this.mapLanguages(serverLanguages);

          this.fetchDefaultLanguage();
        })
        .catch((error) => {
          console.error("Error fetching languages:", error);

          // If there's an error fetching languages, set the default languages from window.config.languages
          this.languages = this.mapLanguages(window.config.languages);
        });
    },
    mapLanguages(
      languageCodes: string[]
    ): { text: string; value: string; flag: string }[] {
      // Define a map of language code to description
      const languageMap: Record<string, string> = {
        de: "Deutsch",
        en: "English",
        it: "Italiano",
        es: "Español",
        ru: "Русский",
        fr: "Français",
      };

      // Map received language codes to the desired format with descriptions
      return languageCodes.map((code) => ({
        text: languageMap[code] || code, // Use description if available, otherwise use code
        value: code,
        flag: code, // Assuming flag is similar to the language code
      }));
    },
    fetchDefaultLanguage(): void {
      const urlLang = this.languages.find(
        (o) => o.value === this.query.countries
      );

      if (urlLang) {
        this.language = this.query.countries;
        this.changeLocale(this.language);
      } else {
        axios
          .get<string>("../REST/loginconfig/config/lang")
          .then((response) => {
            this.language = response.data;
            this.changeLocale(this.language);
          })
          .catch((error) => {
            console.error("Error fetching default language:", error);

            // If there's an error fetching default language, set the default language frow window.config.language
            this.language = window.config.language;
            this.changeLocale(this.language);
          });
      }
    },
    fetchShowReleases(): void {
      axios
        .get<boolean>("../REST/loginconfig/config/show/release")
        .then((response) => {
          const showReleases = response.data;
          this.showReleases = showReleases;

          if (showReleases) {
            //Fetch Releases
            axios
              .get<string[]>("../REST/release/list")
              .then((responseReleases) => {
                this.releases = responseReleases.data;
                const urlRelease = this.releases.find(
                  (o) => o === this.query.release
                );
                if (urlRelease) {
                  this.selectedRelease = urlRelease;
                } else {
                  this.selectedRelease = this.releases[0];
                }
              })
              .catch((errorReleases) => {
                console.error("Error fetching releases:", errorReleases);
              });
          }
        })
        .catch((error) => {
          console.error("Error fetching releases:", error);
        });
    },
    fetchThemes(): void {
      axios
        .get<string[]>("../REST/loginconfig/themes")
        .then((response) => {
          this.themes = response.data.map((theme: string) => ({
            text: theme,
            value: theme.toLowerCase(), // Assuming theme values are lowercase
          }));
          this.fetchDefaultTheme();
        })
        .catch((error) => {
          console.error("Error fetching themes:", error);

          // If there's an error fetching themes, set themes from window.config.themes
          this.themes = window.config.themes;
          this.fetchDefaultTheme();
        });
    },
    fetchDefaultTheme(): void {
      const theme = this.themes.find((o) => o.value === this.query.theme);
      if (theme) {
        //if theme in the url present, set as default
        this.selectedTheme = this.query.theme.toLowerCase();
        this.changeTheme(this.selectedTheme);
      } else {
        const csThemeCookie = Vue.$cookies.get("CS_THEME");
        if (csThemeCookie) {
          // If CS_THEME cookie is present, set the default theme from the cookie
          this.selectedTheme = csThemeCookie.toLowerCase(); // Assuming theme values are lowercase
          this.changeTheme(this.selectedTheme);
        } else {
          // If CS_THEME cookie is not present, fetch default theme from the server
          axios
            .get<string>("../REST/loginconfig/config/theme")
            .then((response) => {
              const defaultTheme: string = response.data; // Default theme value

              // Set the selected theme to the default theme value
              this.selectedTheme = defaultTheme.toLowerCase(); // Assuming theme values are lowercase

              // Call changeTheme method to apply the default theme
              this.changeTheme(this.selectedTheme);
            })
            .catch((error) => {
              console.error("Error fetching default theme:", error);

              // If there's an error fetching default theme, set default theme from window.config.theme
              this.selectedTheme = window.config.theme.toLowerCase(); // Assuming theme values are lowercase

              // Call changeTheme method to apply the default theme
              this.changeTheme(this.selectedTheme);
            });
        }
      }
    },
  },
  mounted: function() {
    this.fetchLanguages();
    //this.fetchDefaultLanguage();
    this.fetchShowReleases();
    this.fetchThemes();
    //this.fetchDefaultTheme();

    const application = document
      .getElementById("application")
      ?.getAttribute("value");
    const isIE = window.navigator
      ? /trident/.test(window.navigator.userAgent.toLowerCase())
      : false;

    let theme = Vue.$cookies.get("CS_THEME");
    if (isIE) {
      theme = "";
      this.$data.themeEnabled = false;
    }

    if (theme) {
      this.$data.theme = theme;
      this.changeTheme(theme);
    }

    this.$data.language = this.defaultLanguage("");

    if (this.query.username && this.query.password) {
      this.$nextTick(this.submitForm);
    } else {
      document.getElementById("username")?.focus();
    }

    this.$data.clientEnabled = false;
    axios
      .get("../REST/adminmandator/enabled?time=" + Date.now())
      .then((response) => {
        this.$data.clientEnabled = response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          console.info("Client(Mandant) is disabled.");
        } else {
          console.error("Error in fetching admin mandator status:", error);
        }
        this.$data.clientEnabled = false;
      });

    if (application === "workspace") {
      this.$data.releaseEnabled = false;
      return;
    }
  },
  computed: {
    query: function() {
      return queryString.parse(window.location.search);
    },
  },
});
